import { IS_ADMIN, IS_ANONYMOUS } from "../../constants/Constants.js";
import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGrid2, faWebhook, faTable, faCog, faWindowRestore, faHeadSideBrain, faAddressCard } from '@fortawesome/pro-light-svg-icons';

const AdminUser = [
  {
    name: "Dashboard",
    url: "/dashboard",
    icon: <FontAwesomeIcon className="tw-w-5 tw-h-5" icon={faGrid2} />,
  },
  {
    name: "Access Management",
    url: "/access",
    icon: <FontAwesomeIcon className="tw-w-5 tw-h-5" icon={faAddressCard} />,
    children: [
      {
        name: "Users",
        url: "/adminUser",
      },
      {
        name: "Groups",
        url: "/groups",
      },
      {
        name: "Authentication",
        url: "/authsection",
        children: [
          {
            name: "LDAP",
            url: "/ldap",
          },
          {
            name: "SAML",
            url: "/saml",
          },
          {
            name: "OpenID",
            url: "/oidc",
          },
          {
            name: "Physical Tokens",
            url: "/physical_tokens",
          }
        ],
      },
    ]
  },

  {
    name: "Infrastructure",
    url: "/infrastructure",
    icon: <FontAwesomeIcon className="tw-w-5 tw-h-5" icon={faWebhook} />,
    children: [
      {
        name: "Docker Agents",
        url: "/agents",
      },
      {
        name: "Servers",
        url: "/servers",
      },
      {
        name: "Pools",
        url: "/server_pools",
      },
      {
        name: "Managers",
        url: "/managers",
      },
      {
        name: "Zones",
        url: "/zones",
      },
      {
        name: "Connection Proxies",
        url: "/connection_proxies",
      },
    
    ]
  },

  {
    name: "Sessions",
    url: "/sessions",
    icon: <FontAwesomeIcon className="tw-w-5 tw-h-5" icon={faTable} />,
    children: [
      {
        name: "Sessions",
        url: "/kasm",
      },
      {
        name: "Staging",
        url: "/staging",
      },
      {
        name: "Casting",
        url: "/cast",
      },
    
    ]
  },
  {
    name: "Workspaces",
    url: "/workspacesection",
    icon: <FontAwesomeIcon className="tw-w-5 tw-h-5" icon={faWindowRestore} />,
    children: [
      {
        name: "Workspaces",
        url: "/workspaces",
      },
      {
        name: "Registry",
        url: "/registry",
      },
    ]
  },

  {
    name: "Settings",
    url: "/settingsection",
    icon: <FontAwesomeIcon className="tw-w-5 tw-h-5" icon={faCog} />,
    children: [
      {
        name: "Global",
        url: "/settings",
      },
      {
        name: "Web Filter",
        url: "/webfilter",
      },
      {
        name: "Branding",
        url: "/branding",
      },
      {
        name: "Storage",
        url: "/storage_providers",
      },    
      {
        name: "Developers",
        url: "/developers",
      },
    ]
  },

  {
    name: "Diagnostics",
    url: "/diagnostics",
    icon: <FontAwesomeIcon className="tw-w-5 tw-h-5" icon={faHeadSideBrain} />,
    children: [
      {
        name: "Logging",
        url: "/logging",
      },
      {
        name: "System Info",
        url: "/systeminfo",
      },
    ]
  }

];

const normalUser = [
  {
    title: true,
    name: "USER",
  },
  {
    name: "Kasm",
    url: "/userdashboard",
    icon: "fa fa-desktop",
  },
  {
    name: "Launch Now",
    url: "/go",
    icon: "fa fa-arrow-circle-right",
  },
  {
    name: "Profile",
    url: "/userprofile",
    icon: "fa fa-user-circle",
  },
  {
    name: "Logout",
    url: "/logout",
    icon: "icon-logout",
  },
];

const anonymousUser = [
  {
    title: true,
    name: "USER",
  },
  {
    name: "Logout",
    url: "/logout",
    icon: "icon-logout",
  },
];

export function routes() {
  return AdminUser
}

export default () => {
  if (IS_ADMIN) {
    return AdminUser;
  } else if (!IS_ANONYMOUS) {
    return normalUser;
  } else {
    return anonymousUser;
  }
};
